import React from 'react';

import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

import { listForNavBar } from './resources/index';

const NameItem = ({ resource }) => (
  <>
    {resource.icon && (
      <span className={'nav-icon nav-icon-custom'}>
        <FontAwesomeIcon icon={resource.icon} />
      </span>
    )}
    {resource.title || resource.name}
  </>
);

export default () => {
  let items = [
    {
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <DashboardOutlinedIcon />
          </span>
          Programmes
        </>
      ),
      url: '/i9',
    },
    ...listForNavBar.map(r => {
      // Allow sub menu
      if (r.children) {
        return {
          name: <NameItem resource={r} />,
          url: '/',
          children: r.children.map(subResource => ({
            name: <NameItem resource={subResource} />,
            url: `/i9/${subResource.name}`,
          })),
        };
      }

      return {
        name: <NameItem resource={r} />,
        url: `/i9/${r.name}`,
      };
    }),
    {
      name: (
        <>
          <span className={'nav-icon nav-icon-custom'}>
            <FontAwesomeIcon icon={faSignOut} />
          </span>
          Sortir d'I9
        </>
      ),
      url: '/',
    },
  ];

  return { items };
};
